/* tslint:disable */
/* eslint-disable */
/**
 * grpc/v1/deals_service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { DealsServiceAddDealFileBody } from '../models'
// @ts-ignore
import { DealsServiceAddDealSupportManagerBody } from '../models'
// @ts-ignore
import { DealsServiceChangeStageBody } from '../models'
// @ts-ignore
import { DealsServiceCheckStageTransitionBody } from '../models'
// @ts-ignore
import { DealsServiceCreateDealCommentBody } from '../models'
// @ts-ignore
import { DealsServiceDeleteDealFileBody } from '../models'
// @ts-ignore
import { DealsServiceRecheckDealFileBody } from '../models'
// @ts-ignore
import { DealsServiceUpdateDealBody } from '../models'
// @ts-ignore
import { DealsServiceUpdateDealCommentBody } from '../models'
// @ts-ignore
import { DealsServiceUpdateDealFileBody } from '../models'
// @ts-ignore
import { DealsServiceVerifyDealFileBody } from '../models'
// @ts-ignore
import { RpcStatus } from '../models'
// @ts-ignore
import { V1AddDealFileResponse } from '../models'
// @ts-ignore
import { V1ChangeStageResponse } from '../models'
// @ts-ignore
import { V1CheckStageTransitionResponse } from '../models'
// @ts-ignore
import { V1CreateDealCommentResponse } from '../models'
// @ts-ignore
import { V1CreateDealRequest } from '../models'
// @ts-ignore
import { V1CreateDealResponse } from '../models'
// @ts-ignore
import { V1DashboardMetricsResponse } from '../models'
// @ts-ignore
import { V1DealSupportManagersResponse } from '../models'
// @ts-ignore
import { V1GetDealActionLogsResponse } from '../models'
// @ts-ignore
import { V1GetDealFinanceSettingsResponse } from '../models'
// @ts-ignore
import { V1GetDealResponse } from '../models'
// @ts-ignore
import { V1GetManagerAnalyticsResponse } from '../models'
// @ts-ignore
import { V1ListDealCommentsResponse } from '../models'
// @ts-ignore
import { V1ListDealFilesResponse } from '../models'
// @ts-ignore
import { V1ListDealManagersResponse } from '../models'
// @ts-ignore
import { V1ListDealsResponse } from '../models'
// @ts-ignore
import { V1RecheckDealFileResponse } from '../models'
// @ts-ignore
import { V1UpdateDealCommentResponse } from '../models'
// @ts-ignore
import { V1UpdateDealFileResponse } from '../models'
// @ts-ignore
import { V1UpdateDealFinanceSettingsRequest } from '../models'
// @ts-ignore
import { V1UpdateDealResponse } from '../models'
// @ts-ignore
import { V1VerifyDealFileResponse } from '../models'
/**
 * DealsServiceApi - axios parameter creator
 * @export
 */
export const DealsServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Attaches an already uploaded file to a deal.
     * @param {string} dealId
     * @param {DealsServiceAddDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceAddDealFile: async (
      dealId: string,
      body: DealsServiceAddDealFileBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceAddDealFile', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceAddDealFile', 'body', body)
      const localVarPath = `/api/v1/deals/{dealId}/files`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * The deal must be open, the person must hold the supporting manager role, and they must not already be the responsible manager. Adding someone who is already helping changes nothing and is not an error. Internal note: allowed for the responsible manager, the head of sales and administrators.
     * @summary Adds a supporting manager to a deal and returns the helpers it has afterwards.
     * @param {string} dealId
     * @param {DealsServiceAddDealSupportManagerBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceAddDealSupportManager: async (
      dealId: string,
      body: DealsServiceAddDealSupportManagerBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceAddDealSupportManager', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceAddDealSupportManager', 'body', body)
      const localVarPath = `/api/v1/deals/{dealId}/support-managers`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Moves a deal to another stage. Moving to a losing stage requires a close reason.
     * @param {string} dealId
     * @param {DealsServiceChangeStageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceChangeStage: async (
      dealId: string,
      body: DealsServiceChangeStageBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceChangeStage', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceChangeStage', 'body', body)
      const localVarPath = `/api/v1/deals/{dealId}/stage`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires deals:read.
     * @summary Answers whether a deal can move to a stage, and what stands in the way: mandatory tasks still open, and whether the target stage is at its work-in-progress limit. Changes nothing.
     * @param {string} dealId
     * @param {DealsServiceCheckStageTransitionBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceCheckStageTransition: async (
      dealId: string,
      body: DealsServiceCheckStageTransitionBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceCheckStageTransition', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceCheckStageTransition', 'body', body)
      const localVarPath = `/api/v1/deals/{dealId}/stage:check`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Creates a deal for a client. The caller becomes the responsible manager.
     * @param {V1CreateDealRequest} body A new deal.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceCreateDeal: async (
      body: V1CreateDealRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceCreateDeal', 'body', body)
      const localVarPath = `/api/v1/deals`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Adds a comment to a deal.
     * @param {string} dealId
     * @param {DealsServiceCreateDealCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceCreateDealComment: async (
      dealId: string,
      body: DealsServiceCreateDealCommentBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceCreateDealComment', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceCreateDealComment', 'body', body)
      const localVarPath = `/api/v1/deals/{dealId}/comments`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Deletes a deal.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceDeleteDeal: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('dealsServiceDeleteDeal', 'id', id)
      const localVarPath = `/api/v1/deals/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Deletes a comment.
     * @param {string} dealId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceDeleteDealComment: async (
      dealId: string,
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceDeleteDealComment', 'dealId', dealId)
      // verify required parameter 'id' is not null or undefined
      assertParamExists('dealsServiceDeleteDealComment', 'id', id)
      const localVarPath = `/api/v1/deals/{dealId}/comments/{id}`
        .replace(`{${'dealId'}}`, encodeURIComponent(String(dealId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: a verb on the collection, not DELETE on the file — the file key is a storage path with slashes, and DELETE carries no body.
     * @summary Detaches a file from a deal.
     * @param {string} dealId
     * @param {DealsServiceDeleteDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceDeleteDealFile: async (
      dealId: string,
      body: DealsServiceDeleteDealFileBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceDeleteDealFile', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceDeleteDealFile', 'body', body)
      const localVarPath = `/api/v1/deals/{dealId}/files:delete`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the deal counters of the caller\'s dashboard: active deals, new deals and how that changed.
     * @param {string} [period] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Defaults to \&quot;week\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceGetDashboardMetrics: async (
      period?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/deals/dashboard-metrics`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (period !== undefined) {
        localVarQueryParameter['period'] = period
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns one deal with its client, listing, manager, history and comments.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceGetDeal: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('dealsServiceGetDeal', 'id', id)
      const localVarPath = `/api/v1/deals/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the history of a deal, newest entries last.
     * @param {string} dealId
     * @param {number} [paginationPageSize] Page size. Zero means the default of the service.
     * @param {string} [paginationPageToken] Cursor taken from next_page_token of the previous response. An empty value asks for the first page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceGetDealActionLogs: async (
      dealId: string,
      paginationPageSize?: number,
      paginationPageToken?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceGetDealActionLogs', 'dealId', dealId)
      const localVarPath = `/api/v1/deals/{dealId}/logs`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPageSize !== undefined) {
        localVarQueryParameter['pagination.pageSize'] = paginationPageSize
      }

      if (paginationPageToken !== undefined) {
        localVarQueryParameter['pagination.pageToken'] = paginationPageToken
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires deals:manage_finance.
     * @summary Returns the parameters every deal is priced with: the head-of-sales rate, the tax, the default VAT and the managers kept out of payroll.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceGetDealFinanceSettings: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/deals/finance/settings`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: restricted to the head of sales and administrators.
     * @summary Returns how managers worked rather than how much they sold: which stages they took part in, how those deals ended, and how many of their tasks were completed or ran late.
     * @param {string} [periodFrom] Start of the window. A manager counts when their stretch of responsibility overlaps it. Empty means no lower bound.
     * @param {string} [periodTo] End of the window. Empty means no upper bound.
     * @param {Array<string>} [managerIds] Managers to include. Empty means all of them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceGetManagerAnalytics: async (
      periodFrom?: string,
      periodTo?: string,
      managerIds?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/deals/manager-analytics`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodFrom !== undefined) {
        localVarQueryParameter['periodFrom'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['periodTo'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      if (managerIds) {
        localVarQueryParameter['managerIds'] = managerIds
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the deals of one client.
     * @param {string} clientId
     * @param {number} [paginationPageSize] Page size. Zero means the default of the service.
     * @param {string} [paginationPageToken] Cursor taken from next_page_token of the previous response. An empty value asks for the first page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListClientDeals: async (
      clientId: string,
      paginationPageSize?: number,
      paginationPageToken?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('dealsServiceListClientDeals', 'clientId', clientId)
      const localVarPath = `/api/v1/deals/client/{clientId}`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPageSize !== undefined) {
        localVarQueryParameter['pagination.pageSize'] = paginationPageSize
      }

      if (paginationPageToken !== undefined) {
        localVarQueryParameter['pagination.pageToken'] = paginationPageToken
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the comments on a deal, oldest first. Author names are resolved by the client from its own list of managers.
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListDealComments: async (
      dealId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceListDealComments', 'dealId', dealId)
      const localVarPath = `/api/v1/deals/{dealId}/comments`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the files attached to a deal.
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListDealFiles: async (
      dealId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceListDealFiles', 'dealId', dealId)
      const localVarPath = `/api/v1/deals/{dealId}/files`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: restricted to the head of sales and administrators, because the data feeds reward calculations.
     * @summary Returns who was responsible for a deal and when, as a chain of stretches covering its whole life.
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListDealManagers: async (
      dealId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceListDealManagers', 'dealId', dealId)
      const localVarPath = `/api/v1/deals/{dealId}/managers`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists deals with filters and cursor paging. This is what fills the kanban board.
     * @param {number} [paginationPageSize] Page size. Zero means the default of the service.
     * @param {string} [paginationPageToken] Cursor taken from next_page_token of the previous response. An empty value asks for the first page.
     * @param {Array<DealsServiceListDealsStageTypesEnum>} [stageTypes] Stages to include. Filtering happens on the server: the kanban board used to take the newest deals and filter them in the browser, which quietly dropped everything past the first page.   - STAGE_TYPE_UNSORTED: Not triaged yet. A hidden stage only the head of sales works with.  - STAGE_TYPE_NEW_LEAD: New lead.  - STAGE_TYPE_NO_CONTACT: Could not be reached.  - STAGE_TYPE_CONTACTED: Reached and talking.  - STAGE_TYPE_QUALIFIED: Qualified: budget and intent are understood.  - STAGE_TYPE_OFFER_SENT: An offer has been sent.  - STAGE_TYPE_PRESENTATION_SCHEDULED: A presentation has been scheduled.  - STAGE_TYPE_PRESENTATION_DONE: The presentation took place.  - STAGE_TYPE_FOLLOWUP_PRESENTATION_DONE: A follow-up meeting or presentation took place.  - STAGE_TYPE_BOOKED: The unit has been reserved.  - STAGE_TYPE_DEPOSIT_PAID: The deposit has been paid.  - STAGE_TYPE_CONTRACT_SIGNED: The reservation contract has been signed and the down payment made.  - STAGE_TYPE_CONTRACT_HANDED_OVER: The original contract has been handed over to the developer.  - STAGE_TYPE_COMMISSION_PAID: The commission has been paid out.  - STAGE_TYPE_LOST: Closed without a sale.
     * @param {DealsServiceListDealsStatusEnum} [status]  - DEAL_STATUS_ACTIVE: Still being worked on.  - DEAL_STATUS_WON: Closed with a sale.  - DEAL_STATUS_LOST: Closed without a sale.  - DEAL_STATUS_CANCELED: Cancelled.
     * @param {string} [responsibleManagerId]
     * @param {string} [clientId]
     * @param {string} [search] Full-text search over the deal title and the text of its comments. Client and manager names are not searched here — they belong to another service, so resolve the client first and filter by its identifier.
     * @param {string} [createdAfter]
     * @param {string} [createdBefore]
     * @param {string} [agentId] Agent the deal came from. Empty is ignored.
     * @param {boolean} [hasAgent] Whether the deal has any agent at all: true leaves only agent deals, false only direct ones. Unset means both.  Internal note: \&quot;direct\&quot; here is the absence of an agent on the deal, not the acquisition channel of the client — those are different things (DEV-1875).
     * @param {string} [clientSourceType] Acquisition channel of the client the deal belongs to: Agent, Direct, Marketing, Referral or Other. Empty is ignored.  Internal note: the channel is a field of the client, so the service asks client-data which clients carry it and filters the deals by the answer (DEV-1979). It is not the same question as has_agent above — that one is about the agent of the deal itself.
     * @param {Array<string>} [leadSourceIds] Lead sources of the client the deal belongs to, as identifiers from the lead source reference book; a deal matches any of them. Empty is ignored.  Internal note: like the channel, the lead source is a field of the client, resolved through client-data into a client_id filter (DEV-2301). Values that are not UUIDs are dropped by the handler.
     * @param {Array<string>} [clientSourceKeys] Filters on the client the deal belongs to — the same set as the client list. Empty ones are ignored; together they narrow the list.  Internal note: a deal knows its client only by identifier, so the service asks client-data for the matching clients (DEV-2301). Values that could not be valid are dropped by the handler: one bad value would otherwise fail the whole request in client-data.  Branches of the lead source tree — a lead source, a site within it or a campaign on that site; a deal matches any of them. Keys come from client-data ListLeadSourceBreakdown.
     * @param {Array<string>} [clientCityIds] Cities of the client, from the city dictionary.
     * @param {string} [clientLanguage] Language the client prefers.
     * @param {Array<string>} [clientTagKeys] Labels the client carries; any of them matches.
     * @param {Array<string>} [clientArchiveReasonIds] Archive reasons of the client; any of them matches. Selecting one leaves only archived clients.
     * @param {string} [clientCreatedAfter] When the lead arrived — the client card, not the deal.
     * @param {string} [clientCreatedBefore]
     * @param {Array<string>} [propertyIds] DEV-2303. ЖК сделки — любой из перечисленных.
     * @param {string} [taskState] DEV-2303. Задачи сделки:   none      — без активных задач: на текущем этапе нет незакрытых (или задач нет вовсе);   overdue   — есть незакрытая просроченная задача, на любом этапе;   today     — на сегодня, в работе: есть невыполненная задача со сроком сегодня;   today_all — на сегодня, все: есть задача со сроком сегодня, выполненная или нет.
     * @param {string} [taskDayStart] Границы сегодняшнего дня в поясе пользователя, [task_day_start, task_day_end). Обязательны для overdue, today и today_all: задача «в течение дня» хранит полночь своего дня в поясе пользователя, и без границ её не отличить от просроченной.
     * @param {string} [taskDayEnd]
     * @param {Array<string>} [responsibleManagerIds] Responsible managers; a deal matches any of them. Combined with responsible_manager_id above, which stays for existing callers.  A value that is not a UUID fails the request (DEV-2475).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListDeals: async (
      paginationPageSize?: number,
      paginationPageToken?: string,
      stageTypes?: Array<DealsServiceListDealsStageTypesEnum>,
      status?: DealsServiceListDealsStatusEnum,
      responsibleManagerId?: string,
      clientId?: string,
      search?: string,
      createdAfter?: string,
      createdBefore?: string,
      agentId?: string,
      hasAgent?: boolean,
      clientSourceType?: string,
      leadSourceIds?: Array<string>,
      clientSourceKeys?: Array<string>,
      clientCityIds?: Array<string>,
      clientLanguage?: string,
      clientTagKeys?: Array<string>,
      clientArchiveReasonIds?: Array<string>,
      clientCreatedAfter?: string,
      clientCreatedBefore?: string,
      propertyIds?: Array<string>,
      taskState?: string,
      taskDayStart?: string,
      taskDayEnd?: string,
      responsibleManagerIds?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/deals`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPageSize !== undefined) {
        localVarQueryParameter['pagination.pageSize'] = paginationPageSize
      }

      if (paginationPageToken !== undefined) {
        localVarQueryParameter['pagination.pageToken'] = paginationPageToken
      }

      if (stageTypes) {
        localVarQueryParameter['stageTypes'] = stageTypes
      }

      if (status !== undefined) {
        localVarQueryParameter['status'] = status
      }

      if (responsibleManagerId !== undefined) {
        localVarQueryParameter['responsibleManagerId'] = responsibleManagerId
      }

      if (clientId !== undefined) {
        localVarQueryParameter['clientId'] = clientId
      }

      if (search !== undefined) {
        localVarQueryParameter['search'] = search
      }

      if (createdAfter !== undefined) {
        localVarQueryParameter['createdAfter'] =
          (createdAfter as any) instanceof Date ? (createdAfter as any).toISOString() : createdAfter
      }

      if (createdBefore !== undefined) {
        localVarQueryParameter['createdBefore'] =
          (createdBefore as any) instanceof Date
            ? (createdBefore as any).toISOString()
            : createdBefore
      }

      if (agentId !== undefined) {
        localVarQueryParameter['agentId'] = agentId
      }

      if (hasAgent !== undefined) {
        localVarQueryParameter['hasAgent'] = hasAgent
      }

      if (clientSourceType !== undefined) {
        localVarQueryParameter['clientSourceType'] = clientSourceType
      }

      if (leadSourceIds) {
        localVarQueryParameter['leadSourceIds'] = leadSourceIds
      }

      if (clientSourceKeys) {
        localVarQueryParameter['clientSourceKeys'] = clientSourceKeys
      }

      if (clientCityIds) {
        localVarQueryParameter['clientCityIds'] = clientCityIds
      }

      if (clientLanguage !== undefined) {
        localVarQueryParameter['clientLanguage'] = clientLanguage
      }

      if (clientTagKeys) {
        localVarQueryParameter['clientTagKeys'] = clientTagKeys
      }

      if (clientArchiveReasonIds) {
        localVarQueryParameter['clientArchiveReasonIds'] = clientArchiveReasonIds
      }

      if (clientCreatedAfter !== undefined) {
        localVarQueryParameter['clientCreatedAfter'] =
          (clientCreatedAfter as any) instanceof Date
            ? (clientCreatedAfter as any).toISOString()
            : clientCreatedAfter
      }

      if (clientCreatedBefore !== undefined) {
        localVarQueryParameter['clientCreatedBefore'] =
          (clientCreatedBefore as any) instanceof Date
            ? (clientCreatedBefore as any).toISOString()
            : clientCreatedBefore
      }

      if (propertyIds) {
        localVarQueryParameter['propertyIds'] = propertyIds
      }

      if (taskState !== undefined) {
        localVarQueryParameter['taskState'] = taskState
      }

      if (taskDayStart !== undefined) {
        localVarQueryParameter['taskDayStart'] =
          (taskDayStart as any) instanceof Date ? (taskDayStart as any).toISOString() : taskDayStart
      }

      if (taskDayEnd !== undefined) {
        localVarQueryParameter['taskDayEnd'] =
          (taskDayEnd as any) instanceof Date ? (taskDayEnd as any).toISOString() : taskDayEnd
      }

      if (responsibleManagerIds) {
        localVarQueryParameter['responsibleManagerIds'] = responsibleManagerIds
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Sends a document back for checking, from the start. Used after a failed check or when the document type has been described better since.
     * @param {string} dealId
     * @param {DealsServiceRecheckDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceRecheckDealFile: async (
      dealId: string,
      body: DealsServiceRecheckDealFileBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceRecheckDealFile', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceRecheckDealFile', 'body', body)
      const localVarPath = `/api/v1/deals/{dealId}/files:recheck`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: allowed for the responsible manager, the head of sales and administrators.
     * @summary Removes a supporting manager from a deal and returns the helpers it has afterwards. Removing someone who is not helping changes nothing and is not an error.
     * @param {string} dealId
     * @param {string} managerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceRemoveDealSupportManager: async (
      dealId: string,
      managerId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceRemoveDealSupportManager', 'dealId', dealId)
      // verify required parameter 'managerId' is not null or undefined
      assertParamExists('dealsServiceRemoveDealSupportManager', 'managerId', managerId)
      const localVarPath = `/api/v1/deals/{dealId}/support-managers/{managerId}`
        .replace(`{${'dealId'}}`, encodeURIComponent(String(dealId)))
        .replace(`{${'managerId'}}`, encodeURIComponent(String(managerId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Changes a deal. Fields left out keep their current values.
     * @param {string} id
     * @param {DealsServiceUpdateDealBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceUpdateDeal: async (
      id: string,
      body: DealsServiceUpdateDealBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('dealsServiceUpdateDeal', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceUpdateDeal', 'body', body)
      const localVarPath = `/api/v1/deals/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Rewrites a comment.
     * @param {string} dealId
     * @param {string} id
     * @param {DealsServiceUpdateDealCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceUpdateDealComment: async (
      dealId: string,
      id: string,
      body: DealsServiceUpdateDealCommentBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceUpdateDealComment', 'dealId', dealId)
      // verify required parameter 'id' is not null or undefined
      assertParamExists('dealsServiceUpdateDealComment', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceUpdateDealComment', 'body', body)
      const localVarPath = `/api/v1/deals/{dealId}/comments/{id}`
        .replace(`{${'dealId'}}`, encodeURIComponent(String(dealId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Renames an attached file or changes its description. The file itself is untouched.
     * @param {string} dealId
     * @param {DealsServiceUpdateDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceUpdateDealFile: async (
      dealId: string,
      body: DealsServiceUpdateDealFileBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceUpdateDealFile', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceUpdateDealFile', 'body', body)
      const localVarPath = `/api/v1/deals/{dealId}/files`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires deals:manage_finance.
     * @summary Replaces those parameters. Changing them re-prices every deal on read, by design: the numbers are derived, never stored.
     * @param {V1UpdateDealFinanceSettingsRequest} body The parameters, in full: the update replaces them rather than patching.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceUpdateDealFinanceSettings: async (
      body: V1UpdateDealFinanceSettingsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceUpdateDealFinanceSettings', 'body', body)
      const localVarPath = `/api/v1/deals/finance/settings`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires deals:update, and the service layer additionally limits it to deals:manage — a manager does not sign off their own deal.
     * @summary Confirms or refuses a document by hand, overriding what the checker decided. The last word stays with a person: the checker can be wrong about an old form or a poor scan.
     * @param {string} dealId
     * @param {DealsServiceVerifyDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceVerifyDealFile: async (
      dealId: string,
      body: DealsServiceVerifyDealFileBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceVerifyDealFile', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceVerifyDealFile', 'body', body)
      const localVarPath = `/api/v1/deals/{dealId}/files:verify`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * DealsServiceApi - functional programming interface
 * @export
 */
export const DealsServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DealsServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Attaches an already uploaded file to a deal.
     * @param {string} dealId
     * @param {DealsServiceAddDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceAddDealFile(
      dealId: string,
      body: DealsServiceAddDealFileBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AddDealFileResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceAddDealFile(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceAddDealFile']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * The deal must be open, the person must hold the supporting manager role, and they must not already be the responsible manager. Adding someone who is already helping changes nothing and is not an error. Internal note: allowed for the responsible manager, the head of sales and administrators.
     * @summary Adds a supporting manager to a deal and returns the helpers it has afterwards.
     * @param {string} dealId
     * @param {DealsServiceAddDealSupportManagerBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceAddDealSupportManager(
      dealId: string,
      body: DealsServiceAddDealSupportManagerBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1DealSupportManagersResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceAddDealSupportManager(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceAddDealSupportManager']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Moves a deal to another stage. Moving to a losing stage requires a close reason.
     * @param {string} dealId
     * @param {DealsServiceChangeStageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceChangeStage(
      dealId: string,
      body: DealsServiceChangeStageBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ChangeStageResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceChangeStage(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceChangeStage']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires deals:read.
     * @summary Answers whether a deal can move to a stage, and what stands in the way: mandatory tasks still open, and whether the target stage is at its work-in-progress limit. Changes nothing.
     * @param {string} dealId
     * @param {DealsServiceCheckStageTransitionBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceCheckStageTransition(
      dealId: string,
      body: DealsServiceCheckStageTransitionBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CheckStageTransitionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceCheckStageTransition(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceCheckStageTransition']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Creates a deal for a client. The caller becomes the responsible manager.
     * @param {V1CreateDealRequest} body A new deal.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceCreateDeal(
      body: V1CreateDealRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateDealResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceCreateDeal(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceCreateDeal']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Adds a comment to a deal.
     * @param {string} dealId
     * @param {DealsServiceCreateDealCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceCreateDealComment(
      dealId: string,
      body: DealsServiceCreateDealCommentBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateDealCommentResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceCreateDealComment(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceCreateDealComment']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Deletes a deal.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceDeleteDeal(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceDeleteDeal(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceDeleteDeal']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Deletes a comment.
     * @param {string} dealId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceDeleteDealComment(
      dealId: string,
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceDeleteDealComment(
        dealId,
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceDeleteDealComment']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: a verb on the collection, not DELETE on the file — the file key is a storage path with slashes, and DELETE carries no body.
     * @summary Detaches a file from a deal.
     * @param {string} dealId
     * @param {DealsServiceDeleteDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceDeleteDealFile(
      dealId: string,
      body: DealsServiceDeleteDealFileBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceDeleteDealFile(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceDeleteDealFile']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the deal counters of the caller\'s dashboard: active deals, new deals and how that changed.
     * @param {string} [period] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Defaults to \&quot;week\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceGetDashboardMetrics(
      period?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1DashboardMetricsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceGetDashboardMetrics(
        period,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceGetDashboardMetrics']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns one deal with its client, listing, manager, history and comments.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceGetDeal(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetDealResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceGetDeal(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceGetDeal']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the history of a deal, newest entries last.
     * @param {string} dealId
     * @param {number} [paginationPageSize] Page size. Zero means the default of the service.
     * @param {string} [paginationPageToken] Cursor taken from next_page_token of the previous response. An empty value asks for the first page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceGetDealActionLogs(
      dealId: string,
      paginationPageSize?: number,
      paginationPageToken?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetDealActionLogsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceGetDealActionLogs(
        dealId,
        paginationPageSize,
        paginationPageToken,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceGetDealActionLogs']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires deals:manage_finance.
     * @summary Returns the parameters every deal is priced with: the head-of-sales rate, the tax, the default VAT and the managers kept out of payroll.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceGetDealFinanceSettings(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetDealFinanceSettingsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.dealsServiceGetDealFinanceSettings(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceGetDealFinanceSettings']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: restricted to the head of sales and administrators.
     * @summary Returns how managers worked rather than how much they sold: which stages they took part in, how those deals ended, and how many of their tasks were completed or ran late.
     * @param {string} [periodFrom] Start of the window. A manager counts when their stretch of responsibility overlaps it. Empty means no lower bound.
     * @param {string} [periodTo] End of the window. Empty means no upper bound.
     * @param {Array<string>} [managerIds] Managers to include. Empty means all of them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceGetManagerAnalytics(
      periodFrom?: string,
      periodTo?: string,
      managerIds?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetManagerAnalyticsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceGetManagerAnalytics(
        periodFrom,
        periodTo,
        managerIds,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceGetManagerAnalytics']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the deals of one client.
     * @param {string} clientId
     * @param {number} [paginationPageSize] Page size. Zero means the default of the service.
     * @param {string} [paginationPageToken] Cursor taken from next_page_token of the previous response. An empty value asks for the first page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceListClientDeals(
      clientId: string,
      paginationPageSize?: number,
      paginationPageToken?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListDealsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceListClientDeals(
        clientId,
        paginationPageSize,
        paginationPageToken,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceListClientDeals']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the comments on a deal, oldest first. Author names are resolved by the client from its own list of managers.
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceListDealComments(
      dealId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListDealCommentsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceListDealComments(
        dealId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceListDealComments']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the files attached to a deal.
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceListDealFiles(
      dealId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListDealFilesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceListDealFiles(
        dealId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceListDealFiles']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: restricted to the head of sales and administrators, because the data feeds reward calculations.
     * @summary Returns who was responsible for a deal and when, as a chain of stretches covering its whole life.
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceListDealManagers(
      dealId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListDealManagersResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceListDealManagers(
        dealId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceListDealManagers']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists deals with filters and cursor paging. This is what fills the kanban board.
     * @param {number} [paginationPageSize] Page size. Zero means the default of the service.
     * @param {string} [paginationPageToken] Cursor taken from next_page_token of the previous response. An empty value asks for the first page.
     * @param {Array<DealsServiceListDealsStageTypesEnum>} [stageTypes] Stages to include. Filtering happens on the server: the kanban board used to take the newest deals and filter them in the browser, which quietly dropped everything past the first page.   - STAGE_TYPE_UNSORTED: Not triaged yet. A hidden stage only the head of sales works with.  - STAGE_TYPE_NEW_LEAD: New lead.  - STAGE_TYPE_NO_CONTACT: Could not be reached.  - STAGE_TYPE_CONTACTED: Reached and talking.  - STAGE_TYPE_QUALIFIED: Qualified: budget and intent are understood.  - STAGE_TYPE_OFFER_SENT: An offer has been sent.  - STAGE_TYPE_PRESENTATION_SCHEDULED: A presentation has been scheduled.  - STAGE_TYPE_PRESENTATION_DONE: The presentation took place.  - STAGE_TYPE_FOLLOWUP_PRESENTATION_DONE: A follow-up meeting or presentation took place.  - STAGE_TYPE_BOOKED: The unit has been reserved.  - STAGE_TYPE_DEPOSIT_PAID: The deposit has been paid.  - STAGE_TYPE_CONTRACT_SIGNED: The reservation contract has been signed and the down payment made.  - STAGE_TYPE_CONTRACT_HANDED_OVER: The original contract has been handed over to the developer.  - STAGE_TYPE_COMMISSION_PAID: The commission has been paid out.  - STAGE_TYPE_LOST: Closed without a sale.
     * @param {DealsServiceListDealsStatusEnum} [status]  - DEAL_STATUS_ACTIVE: Still being worked on.  - DEAL_STATUS_WON: Closed with a sale.  - DEAL_STATUS_LOST: Closed without a sale.  - DEAL_STATUS_CANCELED: Cancelled.
     * @param {string} [responsibleManagerId]
     * @param {string} [clientId]
     * @param {string} [search] Full-text search over the deal title and the text of its comments. Client and manager names are not searched here — they belong to another service, so resolve the client first and filter by its identifier.
     * @param {string} [createdAfter]
     * @param {string} [createdBefore]
     * @param {string} [agentId] Agent the deal came from. Empty is ignored.
     * @param {boolean} [hasAgent] Whether the deal has any agent at all: true leaves only agent deals, false only direct ones. Unset means both.  Internal note: \&quot;direct\&quot; here is the absence of an agent on the deal, not the acquisition channel of the client — those are different things (DEV-1875).
     * @param {string} [clientSourceType] Acquisition channel of the client the deal belongs to: Agent, Direct, Marketing, Referral or Other. Empty is ignored.  Internal note: the channel is a field of the client, so the service asks client-data which clients carry it and filters the deals by the answer (DEV-1979). It is not the same question as has_agent above — that one is about the agent of the deal itself.
     * @param {Array<string>} [leadSourceIds] Lead sources of the client the deal belongs to, as identifiers from the lead source reference book; a deal matches any of them. Empty is ignored.  Internal note: like the channel, the lead source is a field of the client, resolved through client-data into a client_id filter (DEV-2301). Values that are not UUIDs are dropped by the handler.
     * @param {Array<string>} [clientSourceKeys] Filters on the client the deal belongs to — the same set as the client list. Empty ones are ignored; together they narrow the list.  Internal note: a deal knows its client only by identifier, so the service asks client-data for the matching clients (DEV-2301). Values that could not be valid are dropped by the handler: one bad value would otherwise fail the whole request in client-data.  Branches of the lead source tree — a lead source, a site within it or a campaign on that site; a deal matches any of them. Keys come from client-data ListLeadSourceBreakdown.
     * @param {Array<string>} [clientCityIds] Cities of the client, from the city dictionary.
     * @param {string} [clientLanguage] Language the client prefers.
     * @param {Array<string>} [clientTagKeys] Labels the client carries; any of them matches.
     * @param {Array<string>} [clientArchiveReasonIds] Archive reasons of the client; any of them matches. Selecting one leaves only archived clients.
     * @param {string} [clientCreatedAfter] When the lead arrived — the client card, not the deal.
     * @param {string} [clientCreatedBefore]
     * @param {Array<string>} [propertyIds] DEV-2303. ЖК сделки — любой из перечисленных.
     * @param {string} [taskState] DEV-2303. Задачи сделки:   none      — без активных задач: на текущем этапе нет незакрытых (или задач нет вовсе);   overdue   — есть незакрытая просроченная задача, на любом этапе;   today     — на сегодня, в работе: есть невыполненная задача со сроком сегодня;   today_all — на сегодня, все: есть задача со сроком сегодня, выполненная или нет.
     * @param {string} [taskDayStart] Границы сегодняшнего дня в поясе пользователя, [task_day_start, task_day_end). Обязательны для overdue, today и today_all: задача «в течение дня» хранит полночь своего дня в поясе пользователя, и без границ её не отличить от просроченной.
     * @param {string} [taskDayEnd]
     * @param {Array<string>} [responsibleManagerIds] Responsible managers; a deal matches any of them. Combined with responsible_manager_id above, which stays for existing callers.  A value that is not a UUID fails the request (DEV-2475).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceListDeals(
      paginationPageSize?: number,
      paginationPageToken?: string,
      stageTypes?: Array<DealsServiceListDealsStageTypesEnum>,
      status?: DealsServiceListDealsStatusEnum,
      responsibleManagerId?: string,
      clientId?: string,
      search?: string,
      createdAfter?: string,
      createdBefore?: string,
      agentId?: string,
      hasAgent?: boolean,
      clientSourceType?: string,
      leadSourceIds?: Array<string>,
      clientSourceKeys?: Array<string>,
      clientCityIds?: Array<string>,
      clientLanguage?: string,
      clientTagKeys?: Array<string>,
      clientArchiveReasonIds?: Array<string>,
      clientCreatedAfter?: string,
      clientCreatedBefore?: string,
      propertyIds?: Array<string>,
      taskState?: string,
      taskDayStart?: string,
      taskDayEnd?: string,
      responsibleManagerIds?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListDealsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceListDeals(
        paginationPageSize,
        paginationPageToken,
        stageTypes,
        status,
        responsibleManagerId,
        clientId,
        search,
        createdAfter,
        createdBefore,
        agentId,
        hasAgent,
        clientSourceType,
        leadSourceIds,
        clientSourceKeys,
        clientCityIds,
        clientLanguage,
        clientTagKeys,
        clientArchiveReasonIds,
        clientCreatedAfter,
        clientCreatedBefore,
        propertyIds,
        taskState,
        taskDayStart,
        taskDayEnd,
        responsibleManagerIds,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceListDeals']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Sends a document back for checking, from the start. Used after a failed check or when the document type has been described better since.
     * @param {string} dealId
     * @param {DealsServiceRecheckDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceRecheckDealFile(
      dealId: string,
      body: DealsServiceRecheckDealFileBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RecheckDealFileResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceRecheckDealFile(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceRecheckDealFile']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: allowed for the responsible manager, the head of sales and administrators.
     * @summary Removes a supporting manager from a deal and returns the helpers it has afterwards. Removing someone who is not helping changes nothing and is not an error.
     * @param {string} dealId
     * @param {string} managerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceRemoveDealSupportManager(
      dealId: string,
      managerId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1DealSupportManagersResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.dealsServiceRemoveDealSupportManager(
          dealId,
          managerId,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceRemoveDealSupportManager']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Changes a deal. Fields left out keep their current values.
     * @param {string} id
     * @param {DealsServiceUpdateDealBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceUpdateDeal(
      id: string,
      body: DealsServiceUpdateDealBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateDealResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceUpdateDeal(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceUpdateDeal']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Rewrites a comment.
     * @param {string} dealId
     * @param {string} id
     * @param {DealsServiceUpdateDealCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceUpdateDealComment(
      dealId: string,
      id: string,
      body: DealsServiceUpdateDealCommentBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateDealCommentResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceUpdateDealComment(
        dealId,
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceUpdateDealComment']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Renames an attached file or changes its description. The file itself is untouched.
     * @param {string} dealId
     * @param {DealsServiceUpdateDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceUpdateDealFile(
      dealId: string,
      body: DealsServiceUpdateDealFileBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateDealFileResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceUpdateDealFile(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceUpdateDealFile']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires deals:manage_finance.
     * @summary Replaces those parameters. Changing them re-prices every deal on read, by design: the numbers are derived, never stored.
     * @param {V1UpdateDealFinanceSettingsRequest} body The parameters, in full: the update replaces them rather than patching.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceUpdateDealFinanceSettings(
      body: V1UpdateDealFinanceSettingsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetDealFinanceSettingsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.dealsServiceUpdateDealFinanceSettings(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceUpdateDealFinanceSettings']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires deals:update, and the service layer additionally limits it to deals:manage — a manager does not sign off their own deal.
     * @summary Confirms or refuses a document by hand, overriding what the checker decided. The last word stays with a person: the checker can be wrong about an old form or a poor scan.
     * @param {string} dealId
     * @param {DealsServiceVerifyDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceVerifyDealFile(
      dealId: string,
      body: DealsServiceVerifyDealFileBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1VerifyDealFileResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceVerifyDealFile(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceVerifyDealFile']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * DealsServiceApi - factory interface
 * @export
 */
export const DealsServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = DealsServiceApiFp(configuration)
  return {
    /**
     *
     * @summary Attaches an already uploaded file to a deal.
     * @param {string} dealId
     * @param {DealsServiceAddDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceAddDealFile(
      dealId: string,
      body: DealsServiceAddDealFileBody,
      options?: any,
    ): AxiosPromise<V1AddDealFileResponse> {
      return localVarFp
        .dealsServiceAddDealFile(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * The deal must be open, the person must hold the supporting manager role, and they must not already be the responsible manager. Adding someone who is already helping changes nothing and is not an error. Internal note: allowed for the responsible manager, the head of sales and administrators.
     * @summary Adds a supporting manager to a deal and returns the helpers it has afterwards.
     * @param {string} dealId
     * @param {DealsServiceAddDealSupportManagerBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceAddDealSupportManager(
      dealId: string,
      body: DealsServiceAddDealSupportManagerBody,
      options?: any,
    ): AxiosPromise<V1DealSupportManagersResponse> {
      return localVarFp
        .dealsServiceAddDealSupportManager(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Moves a deal to another stage. Moving to a losing stage requires a close reason.
     * @param {string} dealId
     * @param {DealsServiceChangeStageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceChangeStage(
      dealId: string,
      body: DealsServiceChangeStageBody,
      options?: any,
    ): AxiosPromise<V1ChangeStageResponse> {
      return localVarFp
        .dealsServiceChangeStage(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires deals:read.
     * @summary Answers whether a deal can move to a stage, and what stands in the way: mandatory tasks still open, and whether the target stage is at its work-in-progress limit. Changes nothing.
     * @param {string} dealId
     * @param {DealsServiceCheckStageTransitionBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceCheckStageTransition(
      dealId: string,
      body: DealsServiceCheckStageTransitionBody,
      options?: any,
    ): AxiosPromise<V1CheckStageTransitionResponse> {
      return localVarFp
        .dealsServiceCheckStageTransition(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Creates a deal for a client. The caller becomes the responsible manager.
     * @param {V1CreateDealRequest} body A new deal.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceCreateDeal(
      body: V1CreateDealRequest,
      options?: any,
    ): AxiosPromise<V1CreateDealResponse> {
      return localVarFp
        .dealsServiceCreateDeal(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Adds a comment to a deal.
     * @param {string} dealId
     * @param {DealsServiceCreateDealCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceCreateDealComment(
      dealId: string,
      body: DealsServiceCreateDealCommentBody,
      options?: any,
    ): AxiosPromise<V1CreateDealCommentResponse> {
      return localVarFp
        .dealsServiceCreateDealComment(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Deletes a deal.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceDeleteDeal(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .dealsServiceDeleteDeal(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Deletes a comment.
     * @param {string} dealId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceDeleteDealComment(dealId: string, id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .dealsServiceDeleteDealComment(dealId, id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: a verb on the collection, not DELETE on the file — the file key is a storage path with slashes, and DELETE carries no body.
     * @summary Detaches a file from a deal.
     * @param {string} dealId
     * @param {DealsServiceDeleteDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceDeleteDealFile(
      dealId: string,
      body: DealsServiceDeleteDealFileBody,
      options?: any,
    ): AxiosPromise<object> {
      return localVarFp
        .dealsServiceDeleteDealFile(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the deal counters of the caller\'s dashboard: active deals, new deals and how that changed.
     * @param {string} [period] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Defaults to \&quot;week\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceGetDashboardMetrics(
      period?: string,
      options?: any,
    ): AxiosPromise<V1DashboardMetricsResponse> {
      return localVarFp
        .dealsServiceGetDashboardMetrics(period, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns one deal with its client, listing, manager, history and comments.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceGetDeal(id: string, options?: any): AxiosPromise<V1GetDealResponse> {
      return localVarFp.dealsServiceGetDeal(id, options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the history of a deal, newest entries last.
     * @param {string} dealId
     * @param {number} [paginationPageSize] Page size. Zero means the default of the service.
     * @param {string} [paginationPageToken] Cursor taken from next_page_token of the previous response. An empty value asks for the first page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceGetDealActionLogs(
      dealId: string,
      paginationPageSize?: number,
      paginationPageToken?: string,
      options?: any,
    ): AxiosPromise<V1GetDealActionLogsResponse> {
      return localVarFp
        .dealsServiceGetDealActionLogs(dealId, paginationPageSize, paginationPageToken, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires deals:manage_finance.
     * @summary Returns the parameters every deal is priced with: the head-of-sales rate, the tax, the default VAT and the managers kept out of payroll.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceGetDealFinanceSettings(
      options?: any,
    ): AxiosPromise<V1GetDealFinanceSettingsResponse> {
      return localVarFp
        .dealsServiceGetDealFinanceSettings(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: restricted to the head of sales and administrators.
     * @summary Returns how managers worked rather than how much they sold: which stages they took part in, how those deals ended, and how many of their tasks were completed or ran late.
     * @param {string} [periodFrom] Start of the window. A manager counts when their stretch of responsibility overlaps it. Empty means no lower bound.
     * @param {string} [periodTo] End of the window. Empty means no upper bound.
     * @param {Array<string>} [managerIds] Managers to include. Empty means all of them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceGetManagerAnalytics(
      periodFrom?: string,
      periodTo?: string,
      managerIds?: Array<string>,
      options?: any,
    ): AxiosPromise<V1GetManagerAnalyticsResponse> {
      return localVarFp
        .dealsServiceGetManagerAnalytics(periodFrom, periodTo, managerIds, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the deals of one client.
     * @param {string} clientId
     * @param {number} [paginationPageSize] Page size. Zero means the default of the service.
     * @param {string} [paginationPageToken] Cursor taken from next_page_token of the previous response. An empty value asks for the first page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListClientDeals(
      clientId: string,
      paginationPageSize?: number,
      paginationPageToken?: string,
      options?: any,
    ): AxiosPromise<V1ListDealsResponse> {
      return localVarFp
        .dealsServiceListClientDeals(clientId, paginationPageSize, paginationPageToken, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the comments on a deal, oldest first. Author names are resolved by the client from its own list of managers.
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListDealComments(
      dealId: string,
      options?: any,
    ): AxiosPromise<V1ListDealCommentsResponse> {
      return localVarFp
        .dealsServiceListDealComments(dealId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the files attached to a deal.
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListDealFiles(
      dealId: string,
      options?: any,
    ): AxiosPromise<V1ListDealFilesResponse> {
      return localVarFp
        .dealsServiceListDealFiles(dealId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: restricted to the head of sales and administrators, because the data feeds reward calculations.
     * @summary Returns who was responsible for a deal and when, as a chain of stretches covering its whole life.
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListDealManagers(
      dealId: string,
      options?: any,
    ): AxiosPromise<V1ListDealManagersResponse> {
      return localVarFp
        .dealsServiceListDealManagers(dealId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists deals with filters and cursor paging. This is what fills the kanban board.
     * @param {number} [paginationPageSize] Page size. Zero means the default of the service.
     * @param {string} [paginationPageToken] Cursor taken from next_page_token of the previous response. An empty value asks for the first page.
     * @param {Array<DealsServiceListDealsStageTypesEnum>} [stageTypes] Stages to include. Filtering happens on the server: the kanban board used to take the newest deals and filter them in the browser, which quietly dropped everything past the first page.   - STAGE_TYPE_UNSORTED: Not triaged yet. A hidden stage only the head of sales works with.  - STAGE_TYPE_NEW_LEAD: New lead.  - STAGE_TYPE_NO_CONTACT: Could not be reached.  - STAGE_TYPE_CONTACTED: Reached and talking.  - STAGE_TYPE_QUALIFIED: Qualified: budget and intent are understood.  - STAGE_TYPE_OFFER_SENT: An offer has been sent.  - STAGE_TYPE_PRESENTATION_SCHEDULED: A presentation has been scheduled.  - STAGE_TYPE_PRESENTATION_DONE: The presentation took place.  - STAGE_TYPE_FOLLOWUP_PRESENTATION_DONE: A follow-up meeting or presentation took place.  - STAGE_TYPE_BOOKED: The unit has been reserved.  - STAGE_TYPE_DEPOSIT_PAID: The deposit has been paid.  - STAGE_TYPE_CONTRACT_SIGNED: The reservation contract has been signed and the down payment made.  - STAGE_TYPE_CONTRACT_HANDED_OVER: The original contract has been handed over to the developer.  - STAGE_TYPE_COMMISSION_PAID: The commission has been paid out.  - STAGE_TYPE_LOST: Closed without a sale.
     * @param {DealsServiceListDealsStatusEnum} [status]  - DEAL_STATUS_ACTIVE: Still being worked on.  - DEAL_STATUS_WON: Closed with a sale.  - DEAL_STATUS_LOST: Closed without a sale.  - DEAL_STATUS_CANCELED: Cancelled.
     * @param {string} [responsibleManagerId]
     * @param {string} [clientId]
     * @param {string} [search] Full-text search over the deal title and the text of its comments. Client and manager names are not searched here — they belong to another service, so resolve the client first and filter by its identifier.
     * @param {string} [createdAfter]
     * @param {string} [createdBefore]
     * @param {string} [agentId] Agent the deal came from. Empty is ignored.
     * @param {boolean} [hasAgent] Whether the deal has any agent at all: true leaves only agent deals, false only direct ones. Unset means both.  Internal note: \&quot;direct\&quot; here is the absence of an agent on the deal, not the acquisition channel of the client — those are different things (DEV-1875).
     * @param {string} [clientSourceType] Acquisition channel of the client the deal belongs to: Agent, Direct, Marketing, Referral or Other. Empty is ignored.  Internal note: the channel is a field of the client, so the service asks client-data which clients carry it and filters the deals by the answer (DEV-1979). It is not the same question as has_agent above — that one is about the agent of the deal itself.
     * @param {Array<string>} [leadSourceIds] Lead sources of the client the deal belongs to, as identifiers from the lead source reference book; a deal matches any of them. Empty is ignored.  Internal note: like the channel, the lead source is a field of the client, resolved through client-data into a client_id filter (DEV-2301). Values that are not UUIDs are dropped by the handler.
     * @param {Array<string>} [clientSourceKeys] Filters on the client the deal belongs to — the same set as the client list. Empty ones are ignored; together they narrow the list.  Internal note: a deal knows its client only by identifier, so the service asks client-data for the matching clients (DEV-2301). Values that could not be valid are dropped by the handler: one bad value would otherwise fail the whole request in client-data.  Branches of the lead source tree — a lead source, a site within it or a campaign on that site; a deal matches any of them. Keys come from client-data ListLeadSourceBreakdown.
     * @param {Array<string>} [clientCityIds] Cities of the client, from the city dictionary.
     * @param {string} [clientLanguage] Language the client prefers.
     * @param {Array<string>} [clientTagKeys] Labels the client carries; any of them matches.
     * @param {Array<string>} [clientArchiveReasonIds] Archive reasons of the client; any of them matches. Selecting one leaves only archived clients.
     * @param {string} [clientCreatedAfter] When the lead arrived — the client card, not the deal.
     * @param {string} [clientCreatedBefore]
     * @param {Array<string>} [propertyIds] DEV-2303. ЖК сделки — любой из перечисленных.
     * @param {string} [taskState] DEV-2303. Задачи сделки:   none      — без активных задач: на текущем этапе нет незакрытых (или задач нет вовсе);   overdue   — есть незакрытая просроченная задача, на любом этапе;   today     — на сегодня, в работе: есть невыполненная задача со сроком сегодня;   today_all — на сегодня, все: есть задача со сроком сегодня, выполненная или нет.
     * @param {string} [taskDayStart] Границы сегодняшнего дня в поясе пользователя, [task_day_start, task_day_end). Обязательны для overdue, today и today_all: задача «в течение дня» хранит полночь своего дня в поясе пользователя, и без границ её не отличить от просроченной.
     * @param {string} [taskDayEnd]
     * @param {Array<string>} [responsibleManagerIds] Responsible managers; a deal matches any of them. Combined with responsible_manager_id above, which stays for existing callers.  A value that is not a UUID fails the request (DEV-2475).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListDeals(
      paginationPageSize?: number,
      paginationPageToken?: string,
      stageTypes?: Array<DealsServiceListDealsStageTypesEnum>,
      status?: DealsServiceListDealsStatusEnum,
      responsibleManagerId?: string,
      clientId?: string,
      search?: string,
      createdAfter?: string,
      createdBefore?: string,
      agentId?: string,
      hasAgent?: boolean,
      clientSourceType?: string,
      leadSourceIds?: Array<string>,
      clientSourceKeys?: Array<string>,
      clientCityIds?: Array<string>,
      clientLanguage?: string,
      clientTagKeys?: Array<string>,
      clientArchiveReasonIds?: Array<string>,
      clientCreatedAfter?: string,
      clientCreatedBefore?: string,
      propertyIds?: Array<string>,
      taskState?: string,
      taskDayStart?: string,
      taskDayEnd?: string,
      responsibleManagerIds?: Array<string>,
      options?: any,
    ): AxiosPromise<V1ListDealsResponse> {
      return localVarFp
        .dealsServiceListDeals(
          paginationPageSize,
          paginationPageToken,
          stageTypes,
          status,
          responsibleManagerId,
          clientId,
          search,
          createdAfter,
          createdBefore,
          agentId,
          hasAgent,
          clientSourceType,
          leadSourceIds,
          clientSourceKeys,
          clientCityIds,
          clientLanguage,
          clientTagKeys,
          clientArchiveReasonIds,
          clientCreatedAfter,
          clientCreatedBefore,
          propertyIds,
          taskState,
          taskDayStart,
          taskDayEnd,
          responsibleManagerIds,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Sends a document back for checking, from the start. Used after a failed check or when the document type has been described better since.
     * @param {string} dealId
     * @param {DealsServiceRecheckDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceRecheckDealFile(
      dealId: string,
      body: DealsServiceRecheckDealFileBody,
      options?: any,
    ): AxiosPromise<V1RecheckDealFileResponse> {
      return localVarFp
        .dealsServiceRecheckDealFile(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: allowed for the responsible manager, the head of sales and administrators.
     * @summary Removes a supporting manager from a deal and returns the helpers it has afterwards. Removing someone who is not helping changes nothing and is not an error.
     * @param {string} dealId
     * @param {string} managerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceRemoveDealSupportManager(
      dealId: string,
      managerId: string,
      options?: any,
    ): AxiosPromise<V1DealSupportManagersResponse> {
      return localVarFp
        .dealsServiceRemoveDealSupportManager(dealId, managerId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Changes a deal. Fields left out keep their current values.
     * @param {string} id
     * @param {DealsServiceUpdateDealBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceUpdateDeal(
      id: string,
      body: DealsServiceUpdateDealBody,
      options?: any,
    ): AxiosPromise<V1UpdateDealResponse> {
      return localVarFp
        .dealsServiceUpdateDeal(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Rewrites a comment.
     * @param {string} dealId
     * @param {string} id
     * @param {DealsServiceUpdateDealCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceUpdateDealComment(
      dealId: string,
      id: string,
      body: DealsServiceUpdateDealCommentBody,
      options?: any,
    ): AxiosPromise<V1UpdateDealCommentResponse> {
      return localVarFp
        .dealsServiceUpdateDealComment(dealId, id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Renames an attached file or changes its description. The file itself is untouched.
     * @param {string} dealId
     * @param {DealsServiceUpdateDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceUpdateDealFile(
      dealId: string,
      body: DealsServiceUpdateDealFileBody,
      options?: any,
    ): AxiosPromise<V1UpdateDealFileResponse> {
      return localVarFp
        .dealsServiceUpdateDealFile(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires deals:manage_finance.
     * @summary Replaces those parameters. Changing them re-prices every deal on read, by design: the numbers are derived, never stored.
     * @param {V1UpdateDealFinanceSettingsRequest} body The parameters, in full: the update replaces them rather than patching.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceUpdateDealFinanceSettings(
      body: V1UpdateDealFinanceSettingsRequest,
      options?: any,
    ): AxiosPromise<V1GetDealFinanceSettingsResponse> {
      return localVarFp
        .dealsServiceUpdateDealFinanceSettings(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires deals:update, and the service layer additionally limits it to deals:manage — a manager does not sign off their own deal.
     * @summary Confirms or refuses a document by hand, overriding what the checker decided. The last word stays with a person: the checker can be wrong about an old form or a poor scan.
     * @param {string} dealId
     * @param {DealsServiceVerifyDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceVerifyDealFile(
      dealId: string,
      body: DealsServiceVerifyDealFileBody,
      options?: any,
    ): AxiosPromise<V1VerifyDealFileResponse> {
      return localVarFp
        .dealsServiceVerifyDealFile(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * DealsServiceApi - object-oriented interface
 * @export
 * @class DealsServiceApi
 * @extends {BaseAPI}
 */
export class DealsServiceApi extends BaseAPI {
  /**
   *
   * @summary Attaches an already uploaded file to a deal.
   * @param {string} dealId
   * @param {DealsServiceAddDealFileBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceAddDealFile(
    dealId: string,
    body: DealsServiceAddDealFileBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceAddDealFile(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * The deal must be open, the person must hold the supporting manager role, and they must not already be the responsible manager. Adding someone who is already helping changes nothing and is not an error. Internal note: allowed for the responsible manager, the head of sales and administrators.
   * @summary Adds a supporting manager to a deal and returns the helpers it has afterwards.
   * @param {string} dealId
   * @param {DealsServiceAddDealSupportManagerBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceAddDealSupportManager(
    dealId: string,
    body: DealsServiceAddDealSupportManagerBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceAddDealSupportManager(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Moves a deal to another stage. Moving to a losing stage requires a close reason.
   * @param {string} dealId
   * @param {DealsServiceChangeStageBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceChangeStage(
    dealId: string,
    body: DealsServiceChangeStageBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceChangeStage(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires deals:read.
   * @summary Answers whether a deal can move to a stage, and what stands in the way: mandatory tasks still open, and whether the target stage is at its work-in-progress limit. Changes nothing.
   * @param {string} dealId
   * @param {DealsServiceCheckStageTransitionBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceCheckStageTransition(
    dealId: string,
    body: DealsServiceCheckStageTransitionBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceCheckStageTransition(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Creates a deal for a client. The caller becomes the responsible manager.
   * @param {V1CreateDealRequest} body A new deal.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceCreateDeal(body: V1CreateDealRequest, options?: RawAxiosRequestConfig) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceCreateDeal(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Adds a comment to a deal.
   * @param {string} dealId
   * @param {DealsServiceCreateDealCommentBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceCreateDealComment(
    dealId: string,
    body: DealsServiceCreateDealCommentBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceCreateDealComment(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Deletes a deal.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceDeleteDeal(id: string, options?: RawAxiosRequestConfig) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceDeleteDeal(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Deletes a comment.
   * @param {string} dealId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceDeleteDealComment(
    dealId: string,
    id: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceDeleteDealComment(dealId, id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: a verb on the collection, not DELETE on the file — the file key is a storage path with slashes, and DELETE carries no body.
   * @summary Detaches a file from a deal.
   * @param {string} dealId
   * @param {DealsServiceDeleteDealFileBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceDeleteDealFile(
    dealId: string,
    body: DealsServiceDeleteDealFileBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceDeleteDealFile(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the deal counters of the caller\'s dashboard: active deals, new deals and how that changed.
   * @param {string} [period] Period name: \&quot;day\&quot;, \&quot;week\&quot; or \&quot;month\&quot;. Defaults to \&quot;week\&quot;.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceGetDashboardMetrics(period?: string, options?: RawAxiosRequestConfig) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceGetDashboardMetrics(period, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns one deal with its client, listing, manager, history and comments.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceGetDeal(id: string, options?: RawAxiosRequestConfig) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceGetDeal(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the history of a deal, newest entries last.
   * @param {string} dealId
   * @param {number} [paginationPageSize] Page size. Zero means the default of the service.
   * @param {string} [paginationPageToken] Cursor taken from next_page_token of the previous response. An empty value asks for the first page.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceGetDealActionLogs(
    dealId: string,
    paginationPageSize?: number,
    paginationPageToken?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceGetDealActionLogs(dealId, paginationPageSize, paginationPageToken, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires deals:manage_finance.
   * @summary Returns the parameters every deal is priced with: the head-of-sales rate, the tax, the default VAT and the managers kept out of payroll.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceGetDealFinanceSettings(options?: RawAxiosRequestConfig) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceGetDealFinanceSettings(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: restricted to the head of sales and administrators.
   * @summary Returns how managers worked rather than how much they sold: which stages they took part in, how those deals ended, and how many of their tasks were completed or ran late.
   * @param {string} [periodFrom] Start of the window. A manager counts when their stretch of responsibility overlaps it. Empty means no lower bound.
   * @param {string} [periodTo] End of the window. Empty means no upper bound.
   * @param {Array<string>} [managerIds] Managers to include. Empty means all of them.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceGetManagerAnalytics(
    periodFrom?: string,
    periodTo?: string,
    managerIds?: Array<string>,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceGetManagerAnalytics(periodFrom, periodTo, managerIds, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the deals of one client.
   * @param {string} clientId
   * @param {number} [paginationPageSize] Page size. Zero means the default of the service.
   * @param {string} [paginationPageToken] Cursor taken from next_page_token of the previous response. An empty value asks for the first page.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceListClientDeals(
    clientId: string,
    paginationPageSize?: number,
    paginationPageToken?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceListClientDeals(clientId, paginationPageSize, paginationPageToken, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the comments on a deal, oldest first. Author names are resolved by the client from its own list of managers.
   * @param {string} dealId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceListDealComments(dealId: string, options?: RawAxiosRequestConfig) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceListDealComments(dealId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the files attached to a deal.
   * @param {string} dealId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceListDealFiles(dealId: string, options?: RawAxiosRequestConfig) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceListDealFiles(dealId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: restricted to the head of sales and administrators, because the data feeds reward calculations.
   * @summary Returns who was responsible for a deal and when, as a chain of stretches covering its whole life.
   * @param {string} dealId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceListDealManagers(dealId: string, options?: RawAxiosRequestConfig) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceListDealManagers(dealId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists deals with filters and cursor paging. This is what fills the kanban board.
   * @param {number} [paginationPageSize] Page size. Zero means the default of the service.
   * @param {string} [paginationPageToken] Cursor taken from next_page_token of the previous response. An empty value asks for the first page.
   * @param {Array<DealsServiceListDealsStageTypesEnum>} [stageTypes] Stages to include. Filtering happens on the server: the kanban board used to take the newest deals and filter them in the browser, which quietly dropped everything past the first page.   - STAGE_TYPE_UNSORTED: Not triaged yet. A hidden stage only the head of sales works with.  - STAGE_TYPE_NEW_LEAD: New lead.  - STAGE_TYPE_NO_CONTACT: Could not be reached.  - STAGE_TYPE_CONTACTED: Reached and talking.  - STAGE_TYPE_QUALIFIED: Qualified: budget and intent are understood.  - STAGE_TYPE_OFFER_SENT: An offer has been sent.  - STAGE_TYPE_PRESENTATION_SCHEDULED: A presentation has been scheduled.  - STAGE_TYPE_PRESENTATION_DONE: The presentation took place.  - STAGE_TYPE_FOLLOWUP_PRESENTATION_DONE: A follow-up meeting or presentation took place.  - STAGE_TYPE_BOOKED: The unit has been reserved.  - STAGE_TYPE_DEPOSIT_PAID: The deposit has been paid.  - STAGE_TYPE_CONTRACT_SIGNED: The reservation contract has been signed and the down payment made.  - STAGE_TYPE_CONTRACT_HANDED_OVER: The original contract has been handed over to the developer.  - STAGE_TYPE_COMMISSION_PAID: The commission has been paid out.  - STAGE_TYPE_LOST: Closed without a sale.
   * @param {DealsServiceListDealsStatusEnum} [status]  - DEAL_STATUS_ACTIVE: Still being worked on.  - DEAL_STATUS_WON: Closed with a sale.  - DEAL_STATUS_LOST: Closed without a sale.  - DEAL_STATUS_CANCELED: Cancelled.
   * @param {string} [responsibleManagerId]
   * @param {string} [clientId]
   * @param {string} [search] Full-text search over the deal title and the text of its comments. Client and manager names are not searched here — they belong to another service, so resolve the client first and filter by its identifier.
   * @param {string} [createdAfter]
   * @param {string} [createdBefore]
   * @param {string} [agentId] Agent the deal came from. Empty is ignored.
   * @param {boolean} [hasAgent] Whether the deal has any agent at all: true leaves only agent deals, false only direct ones. Unset means both.  Internal note: \&quot;direct\&quot; here is the absence of an agent on the deal, not the acquisition channel of the client — those are different things (DEV-1875).
   * @param {string} [clientSourceType] Acquisition channel of the client the deal belongs to: Agent, Direct, Marketing, Referral or Other. Empty is ignored.  Internal note: the channel is a field of the client, so the service asks client-data which clients carry it and filters the deals by the answer (DEV-1979). It is not the same question as has_agent above — that one is about the agent of the deal itself.
   * @param {Array<string>} [leadSourceIds] Lead sources of the client the deal belongs to, as identifiers from the lead source reference book; a deal matches any of them. Empty is ignored.  Internal note: like the channel, the lead source is a field of the client, resolved through client-data into a client_id filter (DEV-2301). Values that are not UUIDs are dropped by the handler.
   * @param {Array<string>} [clientSourceKeys] Filters on the client the deal belongs to — the same set as the client list. Empty ones are ignored; together they narrow the list.  Internal note: a deal knows its client only by identifier, so the service asks client-data for the matching clients (DEV-2301). Values that could not be valid are dropped by the handler: one bad value would otherwise fail the whole request in client-data.  Branches of the lead source tree — a lead source, a site within it or a campaign on that site; a deal matches any of them. Keys come from client-data ListLeadSourceBreakdown.
   * @param {Array<string>} [clientCityIds] Cities of the client, from the city dictionary.
   * @param {string} [clientLanguage] Language the client prefers.
   * @param {Array<string>} [clientTagKeys] Labels the client carries; any of them matches.
   * @param {Array<string>} [clientArchiveReasonIds] Archive reasons of the client; any of them matches. Selecting one leaves only archived clients.
   * @param {string} [clientCreatedAfter] When the lead arrived — the client card, not the deal.
   * @param {string} [clientCreatedBefore]
   * @param {Array<string>} [propertyIds] DEV-2303. ЖК сделки — любой из перечисленных.
   * @param {string} [taskState] DEV-2303. Задачи сделки:   none      — без активных задач: на текущем этапе нет незакрытых (или задач нет вовсе);   overdue   — есть незакрытая просроченная задача, на любом этапе;   today     — на сегодня, в работе: есть невыполненная задача со сроком сегодня;   today_all — на сегодня, все: есть задача со сроком сегодня, выполненная или нет.
   * @param {string} [taskDayStart] Границы сегодняшнего дня в поясе пользователя, [task_day_start, task_day_end). Обязательны для overdue, today и today_all: задача «в течение дня» хранит полночь своего дня в поясе пользователя, и без границ её не отличить от просроченной.
   * @param {string} [taskDayEnd]
   * @param {Array<string>} [responsibleManagerIds] Responsible managers; a deal matches any of them. Combined with responsible_manager_id above, which stays for existing callers.  A value that is not a UUID fails the request (DEV-2475).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceListDeals(
    paginationPageSize?: number,
    paginationPageToken?: string,
    stageTypes?: Array<DealsServiceListDealsStageTypesEnum>,
    status?: DealsServiceListDealsStatusEnum,
    responsibleManagerId?: string,
    clientId?: string,
    search?: string,
    createdAfter?: string,
    createdBefore?: string,
    agentId?: string,
    hasAgent?: boolean,
    clientSourceType?: string,
    leadSourceIds?: Array<string>,
    clientSourceKeys?: Array<string>,
    clientCityIds?: Array<string>,
    clientLanguage?: string,
    clientTagKeys?: Array<string>,
    clientArchiveReasonIds?: Array<string>,
    clientCreatedAfter?: string,
    clientCreatedBefore?: string,
    propertyIds?: Array<string>,
    taskState?: string,
    taskDayStart?: string,
    taskDayEnd?: string,
    responsibleManagerIds?: Array<string>,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceListDeals(
        paginationPageSize,
        paginationPageToken,
        stageTypes,
        status,
        responsibleManagerId,
        clientId,
        search,
        createdAfter,
        createdBefore,
        agentId,
        hasAgent,
        clientSourceType,
        leadSourceIds,
        clientSourceKeys,
        clientCityIds,
        clientLanguage,
        clientTagKeys,
        clientArchiveReasonIds,
        clientCreatedAfter,
        clientCreatedBefore,
        propertyIds,
        taskState,
        taskDayStart,
        taskDayEnd,
        responsibleManagerIds,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Sends a document back for checking, from the start. Used after a failed check or when the document type has been described better since.
   * @param {string} dealId
   * @param {DealsServiceRecheckDealFileBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceRecheckDealFile(
    dealId: string,
    body: DealsServiceRecheckDealFileBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceRecheckDealFile(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: allowed for the responsible manager, the head of sales and administrators.
   * @summary Removes a supporting manager from a deal and returns the helpers it has afterwards. Removing someone who is not helping changes nothing and is not an error.
   * @param {string} dealId
   * @param {string} managerId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceRemoveDealSupportManager(
    dealId: string,
    managerId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceRemoveDealSupportManager(dealId, managerId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Changes a deal. Fields left out keep their current values.
   * @param {string} id
   * @param {DealsServiceUpdateDealBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceUpdateDeal(
    id: string,
    body: DealsServiceUpdateDealBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceUpdateDeal(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Rewrites a comment.
   * @param {string} dealId
   * @param {string} id
   * @param {DealsServiceUpdateDealCommentBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceUpdateDealComment(
    dealId: string,
    id: string,
    body: DealsServiceUpdateDealCommentBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceUpdateDealComment(dealId, id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Renames an attached file or changes its description. The file itself is untouched.
   * @param {string} dealId
   * @param {DealsServiceUpdateDealFileBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceUpdateDealFile(
    dealId: string,
    body: DealsServiceUpdateDealFileBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceUpdateDealFile(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires deals:manage_finance.
   * @summary Replaces those parameters. Changing them re-prices every deal on read, by design: the numbers are derived, never stored.
   * @param {V1UpdateDealFinanceSettingsRequest} body The parameters, in full: the update replaces them rather than patching.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceUpdateDealFinanceSettings(
    body: V1UpdateDealFinanceSettingsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceUpdateDealFinanceSettings(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires deals:update, and the service layer additionally limits it to deals:manage — a manager does not sign off their own deal.
   * @summary Confirms or refuses a document by hand, overriding what the checker decided. The last word stays with a person: the checker can be wrong about an old form or a poor scan.
   * @param {string} dealId
   * @param {DealsServiceVerifyDealFileBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceVerifyDealFile(
    dealId: string,
    body: DealsServiceVerifyDealFileBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceVerifyDealFile(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * @export
 */
export const DealsServiceListDealsStageTypesEnum = {
  Invalid: 'STAGE_TYPE_INVALID',
  Unsorted: 'STAGE_TYPE_UNSORTED',
  NewLead: 'STAGE_TYPE_NEW_LEAD',
  NoContact: 'STAGE_TYPE_NO_CONTACT',
  Contacted: 'STAGE_TYPE_CONTACTED',
  Qualified: 'STAGE_TYPE_QUALIFIED',
  OfferSent: 'STAGE_TYPE_OFFER_SENT',
  PresentationScheduled: 'STAGE_TYPE_PRESENTATION_SCHEDULED',
  PresentationDone: 'STAGE_TYPE_PRESENTATION_DONE',
  FollowupPresentationDone: 'STAGE_TYPE_FOLLOWUP_PRESENTATION_DONE',
  Booked: 'STAGE_TYPE_BOOKED',
  DepositPaid: 'STAGE_TYPE_DEPOSIT_PAID',
  ContractSigned: 'STAGE_TYPE_CONTRACT_SIGNED',
  ContractHandedOver: 'STAGE_TYPE_CONTRACT_HANDED_OVER',
  CommissionPaid: 'STAGE_TYPE_COMMISSION_PAID',
  Lost: 'STAGE_TYPE_LOST',
} as const
export type DealsServiceListDealsStageTypesEnum =
  (typeof DealsServiceListDealsStageTypesEnum)[keyof typeof DealsServiceListDealsStageTypesEnum]
/**
 * @export
 */
export const DealsServiceListDealsStatusEnum = {
  Invalid: 'DEAL_STATUS_INVALID',
  Active: 'DEAL_STATUS_ACTIVE',
  Won: 'DEAL_STATUS_WON',
  Lost: 'DEAL_STATUS_LOST',
  Canceled: 'DEAL_STATUS_CANCELED',
} as const
export type DealsServiceListDealsStatusEnum =
  (typeof DealsServiceListDealsStatusEnum)[keyof typeof DealsServiceListDealsStatusEnum]
